// Single source of truth for the season rulebook PDF (served from /public).
export const RULEBOOK = {
  url: "/documents/Grid_Masters_2026-2027_Rules_and_Regulations.pdf",
  filename: "Grid_Masters_2026-2027_Rules_and_Regulations.pdf",
  season: "2026-2027",
  revision: "v2",
};
